import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

const App = () => <SwaggerUI url="https://app.brightmoments.io/swagger.json" />;

export default App;
